import { Constants } from "./constants";

export class Recents {

    public bookIds : Array<String> = new Array<String>();
    public type = 'recents';
    public _id =  Constants.USER+'.00.Recents';

}



// WEBPACK FOOTER //
// ./src/app/shared/models/recents.ts